export const emailValidator = {
  methods: {
    validEmail(emailToCheck) {
      const re = /\S+@\S+\.\S+/;
      return re.test(emailToCheck);
    }
  }
};
